export default "/_next/static/images/4ec01d9881efca9605406fc6c2c56701.jpg";